
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, TreeSelect } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

const fields = [{
    "text": "上级字典",
    "field": "parentCode",
    "tree": true
}, {
    "text": "编码",
    "field": "code",
    rules: [
        { required: true, message: '请输字典编码!' },
        { max: 64, message: '最多只能输入32个字符！' }
    ]
}, {
    "text": "名称",
    "field": "name",
    rules: [
        { required: true, message: '请输入字典名称!' },
        { max: 32, message: '最多只能输入32个字符！' }
    ]
}, {
    "text": "说明",
    "field": "des",
    "textarea": true,
    rules: [
        // { max: 128, message: '最多只能输入128个字符！' }
    ]
}, {
    "text": "显示顺",
    "field": "sequence",
    "number": true,
    rules: [
        { required: true, message: '请输入显示顺序!' }
    ]
}];

class DictEditForm extends Component {

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            let state = this.props.editData.state
            if (state !== undefined && state != null) {
                values["state"] = state;
            }
            let category = this.props.editData.category
            values["category"] = category;
            http.post({
                url: '/dict/saveDict',
                data: values,
                success: (res) => {
                    this.props.successCallback({ category: category });
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (data) => {
        const { form, editData, category, dictTree } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let domItem = "";
            let disabledCode = category.treeDict === 1 && item.field === "code";
            if (item.tree && category.treeDict !== 1) {
                continue;
            }
            domItem = (
                <Form.Item label={item.text + "："} key={i}>
                    {getFieldDecorator(item.field, {
                        rules: disabledCode ? [] : item.rules,
                        initialValue: editData[item.field],
                    })(
                        item.tree ? <TreeSelect treeData={dictTree} treeDefaultExpandAll={true} disabled={editData.code != null} showSearch={true} />
                            : item.number ? <InputNumber min={0} max={999} precision={0} style={{ width: '100%' }} />
                                : item.textarea ? <Input.TextArea />
                                    : <Input disabled={disabledCode} />
                    )}
                </Form.Item>
            );
            dom.push(domItem);
        }
        return dom;
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="字典编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const DictEdit = Form.create()(DictEditForm);

export default DictEdit;